import {pathEq, pathOr, omit, compose} from 'ramda';
import {createSelector} from 'reselect';

import {MyFitFiltersType, FiltersStateType} from 'features/myFit/reducers/myFit';
import {ApplicationStoreType} from 'reducers';
import {isCustomerLogged} from 'selectors/customer/customer';
import {getIsFiltersDataFulfilled} from 'selectors/filters/filters';
import {getIsCategoryFulfilled} from 'selectors/category/category';
import {getActiveProduct} from 'selectors/product/product';

import {FRAME_SIZES} from '../constants/constants';

/**
 * Get the My Fit state
 */
export const getMyFitIsEnabled = pathOr<boolean>(false, ['myFit', 'isEnabled']);

/**
 * Get is the My Fit request is fulfilled
 */
export const isMyFitFiltersFetched = pathEq(['myFit', 'filters', 'status'], 'fulfilled');

/**
 * Get the My Fit filters
 */
export const getMyFitFilters = compose<ApplicationStoreType, FiltersStateType, MyFitFiltersType>(
    omit(['status']),
    state => state.myFit.filters,
);

/**
 * Get if the My Fit filters are not empty
 */
export const isMyFitFiltersHasValues = createSelector(getMyFitFilters, (filters): boolean =>
    Boolean(
        Object.values(filters).reduce((acc: number, filter) => acc + Number(filter?.length), 0),
    ),
);

/**
 * Get if we should render the My Fit components
 */
export const shouldRenderMyFit = createSelector(
    isCustomerLogged,
    isMyFitFiltersHasValues,
    getIsFiltersDataFulfilled,
    getIsCategoryFulfilled,
    (...args): boolean => [...args].every(Boolean),
);

export const getIsCurrentSizeInMyFit = createSelector(
    getActiveProduct,
    getMyFitFilters,
    (product, {frame_size: sizes}) => {
        const currentSize = pathOr('', ['frame', 'size', 'label'], product);
        const frameSizes = sizes.map(id => FRAME_SIZES[id]);

        return frameSizes.includes(currentSize);
    },
);
